import React from 'react';
import { Modal } from '@appkit4/react-components/modal';
import { RadioGroup, Radio } from '@appkit4/react-components/radio';
import { Button } from '@appkit4/react-components/button';
import './DownloadModal.scss';

interface DownloadModalProps {
    visible: boolean;
    onClose: () => void;
    onDownload: (type: 'zip' | 'pdf') => void;
}

const DownloadModal: React.FC<DownloadModalProps> = ({
    visible,
    onClose,
    onDownload,
}) => {
    const [downloadType, setDownloadType] = React.useState<'zip' | 'pdf'>(
        'zip'
    );

    const handleDownload = () => {
        onDownload(downloadType);
        onClose();
    };

    return (
        <Modal
            visible={visible}
            title="Download document"
            ariaLabel="Download document Modal"
            className="download-modal"
            onCancel={onClose}
            modalStyle={{ width: '33.75rem' }}
            footerStyle={{
                paddingTop: '8px',
                marginTop: '-8px',
                minHeight: '64px',
            }}
            bodyStyle={{ minHeight: '92px' }}
            placement="center"
        >
            <div className="download-modal-content">
                <p className="download-instruction">
                    Please select the type you would like to download your file
                    with
                </p>
                <RadioGroup
                    value={downloadType}
                    onChange={(value: any) =>
                        setDownloadType(value as 'zip' | 'pdf')
                    }
                >
                    <Radio value="zip">Download as ZIP</Radio>
                    <Radio value="pdf">Download as combined PDF</Radio>
                </RadioGroup>
                <div className="download-button-container">
                    <Button
                        variant="primary"
                        onClick={handleDownload}
                        className="download-button"
                    >
                        Download
                    </Button>
                </div>
            </div>
        </Modal>
    );
};

export default DownloadModal;
